import React from 'react';
import { Link, type TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import clientConfig from '../config.client';

export type Props = {
    href?: string,
    text?: string,
    title?: string,
    blank?: boolean,
    reload?: boolean,
    onClick?: (ev) => void
    children?: JSX.Element | JSX.Element[] | string
} & TypographyProps

const LinkStyled = styled(Link)`
    text-decoration: none;
`;

export default class Anchor extends React.Component<Props> {
    reload(ev) {
        ev.preventDefault();
        window.location.reload();
    }

    render() {
        const {
            title,
            text,
            href,
            blank,
            children,
            reload,
            ...other
        } = this.props;

        const attributes: any = {
            title: title || text,
            href,
        };

        if (reload) {
            attributes.onClick = this.reload;
            attributes.href = '#';
        }

        if (blank) {
            attributes.target = '_blank';
            if (href && href.indexOf('www') !== -1 && href.indexOf(clientConfig.baseUrl) === -1) attributes.rel = 'noopener';
        }

        return <LinkStyled {...(other || {})} {...attributes}>
            {children || text}
        </LinkStyled>;
    }
}
